import type { ForecastLabel } from '../../types/mavis';
import { FORECAST_LABEL_LABELS } from '../../types/mavis';

const LABEL_STYLES: Record<ForecastLabel, string> = {
  low:          'bg-app-canvas text-app-muted',
  medium:       'bg-sky-100 text-sky-700',
  high:         'bg-indigo-100 text-indigo-700',
  commit_risk:  'bg-red-100 text-red-700',
  commit_ready: 'bg-forest-100 text-forest-700',
};

interface Props {
  label: ForecastLabel;
  size?: 'sm' | 'md';
}

export default function MavisForecastLabelChip({ label, size = 'sm' }: Props) {
  return (
    <span
      className={`inline-flex items-center rounded-full font-medium whitespace-nowrap ${
        size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-sm'
      } ${LABEL_STYLES[label]}`}
    >
      {FORECAST_LABEL_LABELS[label]}
    </span>
  );
}
